import type { FunctionComponent } from "react";
import { CommunicationAdminPartial } from "../../../partials/admin/communication/communication.admin.partials";

export const CommunicationAdminScreen: FunctionComponent = () => {
	return <CommunicationAdminPartial />;
};
